import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { RouteConfig } from "vue-router";
import { asyncRoutes, constantRoutes } from "@/router";
import store from "@/store";

let FourLevelPages: any = []

// 处理id
const dealId = (val: any) => {
    for (let item of val) {
        if (item.id) {
            delete item.id
        }

        if (item.children && item.children.length > 0) {
            dealId(item.children)
        }
    }
}

// 处理children衔接
const IndustryData = (arr: any) => {
    arr.forEach((v: any) => {
        if (v.l) {
            v.children = v.l
        }

        if (v.children && v.children.length > 0) {
            IndustryData(v.children)
        }
    })
}


// 处理权限
const filterAsyncRoutes = (val: any, data: any) => {
    val.forEach((item: any) => {
        if (item.meta.id == data.id) {
            if (item.meta) {
                data.meta = item.meta
                data.meta.title = data.n ? data.n : item.meta.title
                data.meta.icon = data.i ? data.i : item.meta.icon
                data.meta.noCache = item.meta.noCache ? item.meta.noCache : false;
            }

            if (item.path) {
                data.path = item.path
            }

            if (item.component) {
                data.component = item.component
            }

            if (item.name) {
                data.name = item.name
            }

            if (item.redirect && item.redirect != undefined) {
                data.redirect = item.redirect
            }

            if (data.l) {
                data.children = JSON.parse(JSON.stringify(data.l))
            }

            delete data.t
            delete data.i
            delete data.u
            delete data.n
            delete data.a
            delete data.l
        }

        if (item.meta.level == 4) {
            FourLevelPages.push(item)
        }

        if (item.children) {
            filterAsyncRoutes(item.children, data)
        }
    })
}

// 处理权限生成
const dealAsyncRoutes = (val: any) => {
    const result: any = [];

    val.forEach((item: any) => {
        dealOthers(item)

        if (item.l) {
            let res;
            res = dealAsyncRoutes(item.l)
        }
    })
}

const dealOthers = (data: any) => {
    filterAsyncRoutes(asyncRoutes, data)

    if (data.children) {
        for (let item of data.children) {
            dealOthers(item)
        }
    }
}

const dealAllRoutes = (val: any): void => {
    for (var i = 0; i < val.length; i++) {
        if (val[i].path == undefined) {
            val.splice(i, 1);
            i--;
        }

        if (val[i] && val[i].children) {
            dealAllRoutes(val[i].children)
        }

    }
}

export interface IPermissionState {
    dynamicRoutes: RouteConfig[];
}

@Module({ dynamic: true, store, name: "permission" })
class Permission extends VuexModule implements IPermissionState {
    public dynamicRoutes: RouteConfig[] = [];
    public sideMenus: any[] = [];

    /* 
     * 生成动态路由
    */
    @Mutation
    private SET_ROUTES(routes: RouteConfig[]) {
        this.dynamicRoutes = constantRoutes.concat(routes)
    }

    @Action({ rawError: true })
    public async GenerateMenu(routes: any) {
        let arr: Array<any> = JSON.parse(JSON.stringify(routes))

        console.log(arr);
        
        IndustryData(arr)
        dealAsyncRoutes(arr)
        dealId(arr)

        const set: Array<any> = [...new Set(FourLevelPages)]
        let allRoutes: Array<any> = arr.concat(set)

        /* 
         * 排除掉文件中没有建立路由,而某个权限又被创建的情况
        */
        dealAllRoutes(allRoutes);
        this.SET_ROUTES(allRoutes);
    }
}

export const PermissionModule = getModule(Permission);
